// src/context/ClientThemeContext.js
import { createContext, useContext, useState, useEffect } from "react";

const ClientThemeContext = createContext();

export const ClientThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const savedTheme = localStorage.getItem("client-theme"); // Different key
    if (savedTheme) setTheme(savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("client-theme", newTheme); // Different key
  };

  const changeTheme = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem("client-theme", newTheme); // Different key
  };

  return (
    <ClientThemeContext.Provider value={{ theme, toggleTheme, changeTheme }}>
      <div className={`theme-${theme}`}>{children}</div>
    </ClientThemeContext.Provider>
  );
};

export const useClientTheme = () => useContext(ClientThemeContext);
